export var MessagesList = {
  2: { parts_length: 0 },
  59: ["string"],
  60: {
    parts_length: 1,
    data: [{ name: "settings", type: "string" }],
  },
  61: ["string"],
  63: {
    parts_length: 12,
    data: [
      { name: "server_seed_SHA256", type: "string" },
      { name: "client_seed", type: "string" },
      { name: "nonce", type: "int" },
      { name: "balance", type: "number" },
      { name: "user_id", type: "string" },
      { name: "user_name", type: "base64" },
      {
        name: "game_settings",
        type: "objects",
        delimeter: "|",
        parts_length: 2,
        obj: [
          { name: "coefs", type: "table", delimeter: ";", subdelimeter: ":" },
          { name: "maxWin", type: "number" },
        ],
      },
      { name: "minBet", type: "number" },
      { name: "maxBet", type: "number" },
      { name: "currency", type: "string" },
      { name: "precision", type: "number" },
      { name: "next_server_seed_SHA256", type: "string" },
    ],
  },
  67: {
    parts_length: 13,
    data: [
      { name: "round_id", type: "string" },
      { name: "user_name", type: "base64" },
      { name: "user_id", type: "string" },
      { name: "betAmount", type: "number" },
      { name: "winAmount", type: "number" },
      { name: "winCoef", type: "number" },
      { name: "currency", type: "string" },
      { name: "bigWin", type: "int" },
      { name: "bet_id", type: "int" },
      { name: "history", type: "int" },
      { name: "time", type: "string" },
      { name: "gameplay", type: "string" },
      { name: "sessionNo", type: "string" },
    ],
  },
  72: ["number"],
  90: {
    parts_length: 1,
    data: [{ name: "errorCode", type: "int" }],
  },
  101: ["string"],
  102: ["number"],
  103: {
    parts_length: 6,
    data: [
      { name: "cards", type: "array", delimeter: ";" },
      { name: "balance", type: "number" },
      { name: "wintype", type: "int" },
      { name: "wincoef", type: "number" },
      { name: "winamount", type: "number" },
      { name: "winPositions", type: "array", delimeter: ";" },
    ],
  },
  104: ["array"],
  105: {
    parts_length: 5,
    data: [
      { name: "cards", type: "array", delimeter: ";" },
      { name: "wintype", type: "int" },
      { name: "wincoef", type: "number" },
      { name: "winamount", type: "number" },
      { name: "winPositions", type: "array", delimeter: ";" },
    ],
  },
  106: {},
  107: {
    parts_length: 1,
    data: [{ name: "balance", type: "number" }],
  },
  108: {},
  109: {
    parts_length: 5,
    data: [
      { name: "balance", type: "number" },
      { name: "wintype", type: "int" },
      { name: "wincoef", type: "number" },
      { name: "winamount", type: "number" },
      { name: "history", type: "array", delimeter: ";" },
    ],
  },
  110: {},
  111: {},
  112: ["string"],
  113: {
    parts_length: 5,
    data: [
      { name: "card", type: "string" },
      { name: "win", type: "int" },
      { name: "initialamount", type: "number" },
      { name: "winamount", type: "number" },
      { name: "history", type: "array", delimeter: ";" },
    ],
  },
  114: ["string"],
  115: {
    parts_length: 1,
    data: [
      {
        name: "winstats",
        type: "arrayobjects",
        parts_length: 2,
        delimeter: ";",
        obj: {
          delimeter: "|",
          data: [
            { name: "wintype", type: "int" },
            { name: "wincount", type: "int" },
          ],
        },
      },
    ],
  },
  116: ["string"],
  117: {
    parts_length: 21,
    data: [
      { name: "user_id", type: "string" },
      { name: "user_name", type: "base64" },
      { name: "bet_id", type: "int" },
      { name: "round_id", type: "string" },
      { name: "betAmount", type: "number" },
      { name: "winAmount", type: "number" },
      { name: "currency", type: "string" },
      { name: "winCoef", type: "number" },
      { name: "bigWin", type: "int" },
      { name: "server_seed", type: "string" },
      { name: "server_seed_SHA256", type: "string" },
      { name: "client_seed", type: "string" },
      { name: "nonce", type: "int" },
      { name: "date", type: "string" },
      { name: "cardsfirst", type: "array", delimeter: ":" },
      { name: "cardsfinal", type: "array", delimeter: ":" },
      { name: "lockState", type: "array", delimeter: ":" },
      { name: "winpositions", type: "array", delimeter: ":" },
      {
        name: "doubleup",
        type: "arrayobjects",
        delimeter: ":",
        parts_length: 1,
        obj: {
          delimeter: "|",
          type: "object",
          parts_length: 3,
          data: [
            { name: "type", type: "string" },
            { name: "card", type: "string" },
            { name: "coeff", type: "string" },
            { name: "amount", type: "string" },
          ],
        },
      },
      { name: "wintype", type: "string" },
      { name: "state", type: "string" },
    ],
  },
  118: {
    parts_length: 7,
    data: [
      { name: "server_seed_SHA256", type: "string" },
      { name: "client_seed", type: "string" },
      { name: "nonce", type: "int" },

      { name: "old_server_seed", type: "string" },
      { name: "old_server_seed_SHA256", type: "string" },
      { name: "old_client_seed", type: "string" },
      { name: "old_nonce", type: "int" },
    ],
  },
  119: {
    parts_length: 8,
    data: [
      { name: "server_seed_SHA256", type: "string" },
      { name: "client_seed", type: "string" },
      { name: "nonce", type: "int" },
      { name: "old_server_seed", type: "string" },
      { name: "old_server_seed_SHA256", type: "string" },
      { name: "old_client_seed", type: "string" },
      { name: "old_nonce", type: "int" },
      { name: "next_server_seed_SHA256", type: "string" },
    ],
  },
  124: ["number"],
  125: ["object"],
  126: {},
  127: {
    parts_length: 9,
    data: [
      { name: "cards", type: "array", delimeter: ";" },
      { name: "balance", type: "number" },
      { name: "wintype", type: "int" },
      { name: "wincoef", type: "number" },
      { name: "winamount", type: "number" },
      { name: "winPositions", type: "array", delimeter: ";" },
      { name: "history", type: "array", delimeter: ";" },
      { name: "state", type: "number" },
      { name: "doubleupcard", type: "string" },
    ],
  },
};
